module.exports = __webpack_public_path__ + "img/576.2d177168.jpg";